// Links carry a trailing slash and are all lowercase so they point straight at
// the URL Netlify actually serves. Netlify 301s both the slashless form and any
// uppercase characters, so "/aboutGoldCoast" would cost a redirect hop.
export const menuData = [
  { title: "Home", link: "/" },
  { title: "Reservations", link: "/reservations/" },
  { title: "Cottages", link: "/cottages/" },
  { title: "Rates", link: "/rates/" },
  { title: "About Gold Coast", link: "/aboutgoldcoast/" },
  { title: "About Tofino", link: "/abouttofino/" },
  { title: "Gallery", link: "/gallery/" },
  { title: "Contact", link: "/contact/" },
  { title: "Location", link: "/location/" },
  { title: "Getting Here", link: "/gettinghere/" },
]
